import styled from 'styled-components';
import * as colors from '~/config/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 1400px) { //980
      flex-direction: column;                 
  } 

  
  @media (max-width: 600px) { //980
    flex-direction: column;             
  }    
 

  .Container__info_01 { 
    border: 10px solid #FFFFFF;    
    width: 100%; 
    height: 100%;   

    p {      
        margin-bottom: 5px;
        font-size: 1.6rem;       
        color : black;
        font-weight: 400;
        //letter-spacing: 1px;        
        text-align: left;        

    }
   
  }

  .Container__info_02 {   
    max-width: 500px;  
    margin: auto;    
  }

  .Container__info_03 {    
    max-width: 500px;     
    margin: auto;
    
  }





  /* > .MuiFormControl-root {
    margin-bottom: 2rem;
  }

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0 !important;
  } */
`;

